(() => {
var $a2c1c221aac1d794$exports = {};
(function() {
    /*
   WooCommerce SkyVerge Payment Gateway Framework Payment Form CoffeeScript
   Version 4.3.0

   Copyright (c) 2014-2024, SkyVerge, Inc.
   Licensed under the GNU General Public License v3.0
   http://www.gnu.org/licenses/gpl-3.0.html
  */ var indexOf = [].indexOf;
    jQuery(function($) {
        "use strict";
        window.SV_WC_Payment_Form_Handler_v5_15_12 = class SV_WC_Payment_Form_Handler_v5_15_12 {
            // Public: Instantiate Payment Form Handler
            // args - object with properties:
            //   id - gateway ID
            //   id_dasherized - gateway ID dasherized
            //   plugin_id - plugin ID
            //   type - gateway type, either `credit-card` or `echeck`
            //   csc_required - true if the gateway requires the CSC field to be displayed
            // Returns SV_WC_Payment_Form_Handler_v5_15_12 instance
            constructor(args){
                this.id = args.id;
                this.id_dasherized = args.id_dasherized;
                this.plugin_id = args.plugin_id;
                this.type = args.type;
                this.csc_required = args.csc_required;
                this.csc_required_for_tokens = args.csc_required_for_tokens;
                this.enabled_card_types = args.enabled_card_types;
                // which payment form?
                if ($('form.checkout').length) {
                    this.form = $('form.checkout');
                    this.handle_checkout_page();
                } else if ($('form#order_review').length) {
                    this.form = $('form#order_review');
                    this.handle_pay_page();
                } else if ($('form#add_payment_method').length) {
                    this.form = $('form#add_payment_method');
                    this.handle_add_payment_method_page();
                } else {
                    console.log('No payment form found!');
                    return;
                }
                // localized error messages
                this.params = window["sv_wc_payment_gateway_payment_form_params"];
                if (this.type === 'echeck') // handle sample check image hint
                this.form.on('click', '.js-sv-wc-payment-gateway-echeck-form-check-hint, .js-sv-wc-payment-gateway-echeck-form-sample-check', ()=>{
                    return this.handle_sample_check_hint();
                });
                $(document).trigger('sv_wc_payment_form_handler_init', {
                    id: this.id,
                    instance: this
                });
            }
            // Public: Handle required actions on the checkout page
            // Returns nothing.
            handle_checkout_page() {
                if (this.type === 'credit-card') // format/validate credit card inputs using jQuery.payment
                $(document.body).on('updated_checkout', ()=>{
                    return this.format_credit_card_inputs();
                });
                // updated payment fields jQuery object on each checkout update (prevents stale data)
                $(document.body).on('updated_checkout', ()=>{
                    return this.set_payment_fields();
                });
                // handle saved payment methods
                // note on the checkout page, this is bound to `updated_checkout` so it
                // fires even when other parts of the checkout are changed
                $(document.body).on('updated_checkout', ()=>{
                    return this.handle_saved_payment_methods();
                });
                // validate payment data before order is submitted
                return this.form.on(`checkout_place_order_${this.id}`, ()=>{
                    return this.validate_payment_data();
                });
            }
            // Public: Handle required actions on the Order > Pay page
            // Returns nothing.
            handle_pay_page() {
                this.set_payment_fields();
                // format/validate credit card inputs using jQuery.payment
                if (this.type === 'credit-card') this.format_credit_card_inputs();
                // handle saved payment methods
                this.handle_saved_payment_methods();
                // validate payment data before order is submitted
                return this.form.submit(()=>{
                    if ($('#order_review input[name=payment_method]:checked').val() === this.id) // but only when one of our payment gateways is selected
                    return this.validate_payment_data();
                });
            }
            // Public: Handle required actions on the Add Payment Method page
            // Returns nothing.
            handle_add_payment_method_page() {
                this.set_payment_fields();
                // format/validate credit card inputs using jQuery.payment
                if (this.type === 'credit-card') this.format_credit_card_inputs();
                // validate payment data before order is submitted
                return this.form.submit(()=>{
                    if ($('#add_payment_method input[name=payment_method]:checked').val() === this.id) // but only when one of our payment gateways is selected
                    return this.validate_payment_data();
                });
            }
            // Public: Set payment fields class variable, this is done
            // during the updated_checkout event as otherwise the reference to
            // the checkout fields becomes stale (somehow ¯\_(ツ)_/¯)
            // This ensures payment fields are not marked as "invalid" before the customer has interacted with them.
            // Returns nothing.
            set_payment_fields() {
                var $required_fields;
                this.payment_fields = $(`.payment_method_${this.id}`);
                $required_fields = this.payment_fields.find('.validate-required .input-text');
                return $required_fields.each((i, input)=>{
                    // if any of the required fields have a value, bail this loop and proceed with WooCommerce validation
                    if ($(input).val()) return false;
                    // otherwise remove all validation result classes from the inputs, since the form is freshly loaded
                    return $(input).trigger('input');
                });
            }
            // Public: Validate Payment data when order is placed
            // Returns boolean, true if payment data is valid, false otherwise
            validate_payment_data() {
                var handler, valid;
                if (this.form.is('.processing')) // bail when already processing
                return false;
                this.saved_payment_method_selected = this.payment_fields.find('.js-sv-wc-payment-gateway-payment-token:checked').val();
                // perform internal validations (all fields present & valid, etc)
                valid = this.type === 'credit-card' ? this.validate_card_data() : this.validate_account_data();
                // let gateways perform their own validation prior to form submission
                handler = $(document.body).triggerHandler('sv_wc_payment_form_valid_payment_data', {
                    payment_form: this,
                    passed_validation: valid
                }) !== false;
                return valid && handler;
            }
            // Public: format card data using jQuery.Payment
            // Returns nothing.
            format_credit_card_inputs() {
                var $card_number, $csc, $expiry;
                $card_number = $('.js-sv-wc-payment-gateway-credit-card-form-account-number').payment('formatCardNumber');
                $expiry = $('.js-sv-wc-payment-gateway-credit-card-form-expiry').payment('formatCardExpiry');
                $csc = $('.js-sv-wc-payment-gateway-credit-card-form-csc').payment('formatCardCVC');
                if ($card_number.val() && $card_number.val().length > 0) $card_number.trigger('change');
                if ($expiry.val() && $expiry.val().length > 0) $expiry.trigger('change');
                if ($csc.val() && $csc.val().length > 0) $csc.trigger('change');
                // perform inline validation on credit card inputs
                return $('.js-sv-wc-payment-gateway-credit-card-form-input').on('change paste keyup', ()=>{
                    return this.do_inline_credit_card_validation();
                });
            }
            // Public: perform inline validation on credit card fields
            // Returns nothing.
            do_inline_credit_card_validation() {
                var $card_number, $card_type, $csc, $expiry;
                $card_number = $('.js-sv-wc-payment-gateway-credit-card-form-account-number');
                $expiry = $('.js-sv-wc-payment-gateway-credit-card-form-expiry');
                $csc = $('.js-sv-wc-payment-gateway-credit-card-form-csc');
                $card_type = $.payment.cardType($card_number.val());
                if (indexOf.call(this.enabled_card_types, $card_type) < 0) $card_number.addClass('invalid-card-type');
                else $card_number.removeClass('invalid-card-type');
                if ($.payment.validateCardExpiry($expiry.payment('cardExpiryVal'))) $expiry.addClass('identified');
                else $expiry.removeClass('identified');
                if ($.payment.validateCardCVC($csc.val())) return $csc.addClass('identified');
                else return $csc.removeClass('identified');
            }
            // Public: Perform validation on the credit card info entered
            // Return boolean, true if credit card info is valid, false otherwise
            validate_card_data() {
                var account_number, csc, errors, expiry;
                errors = [];
                csc = this.payment_fields.find('.js-sv-wc-payment-gateway-credit-card-form-csc').val();
                // always validate the CSC if present
                if (csc != null) {
                    if (csc) {
                        if (/\D/.test(csc)) errors.push(this.params.cvv_digits_invalid);
                        if (csc.length < 3 || csc.length > 4) errors.push(this.params.cvv_length_invalid);
                    } else if (this.csc_required) {
                        if (!this.saved_payment_method_selected || this.csc_required_for_tokens) errors.push(this.params.cvv_missing);
                    }
                }
                // Only validate the other CC fields if necessary
                if (!this.saved_payment_method_selected) {
                    account_number = this.payment_fields.find('.js-sv-wc-payment-gateway-credit-card-form-account-number').val();
                    expiry = $.payment.cardExpiryVal(this.payment_fields.find('.js-sv-wc-payment-gateway-credit-card-form-expiry').val());
                    // replace any dashes or spaces in the card number
                    account_number = account_number.replace(/-|\s/g, '');
                    // validate card number
                    if (!account_number) errors.push(this.params.card_number_missing);
                    else {
                        if (account_number.length < 12 || account_number.length > 19) errors.push(this.params.card_number_length_invalid);
                        if (/\D/.test(account_number)) errors.push(this.params.card_number_digits_invalid);
                        if (!$.payment.validateCardNumber(account_number)) errors.push(this.params.card_number_invalid);
                    }
                    if (!$.payment.validateCardExpiry(expiry)) // validate expiration date
                    errors.push(this.params.card_exp_date_invalid);
                }
                if (errors.length > 0) {
                    this.render_errors(errors);
                    return false;
                } else {
                    // get rid of any space/dash characters
                    this.payment_fields.find('.js-sv-wc-payment-gateway-credit-card-form-account-number').val(account_number);
                    return true;
                }
            }
            // Public: Perform validation on the eCheck info entered
            // Return boolean, true if eCheck info is valid, false otherwise
            validate_account_data() {
                var account_number, errors, routing_number;
                if (this.saved_payment_method_selected) return true;
                errors = [];
                routing_number = this.payment_fields.find('.js-sv-wc-payment-gateway-echeck-form-routing-number').val();
                account_number = this.payment_fields.find('.js-sv-wc-payment-gateway-echeck-form-account-number').val();
                // validate routing number
                if (!routing_number) errors.push(this.params.routing_number_missing);
                else {
                    if (9 !== routing_number.length) errors.push(this.params.routing_number_length_invalid);
                    if (/\D/.test(routing_number)) errors.push(this.params.routing_number_digits_invalid);
                }
                // validate account number
                if (!account_number) errors.push(this.params.account_number_missing);
                else {
                    if (account_number.length < 3 || account_number.length > 17) errors.push(this.params.account_number_length_invalid);
                    if (/\D/.test(account_number)) errors.push(this.params.account_number_invalid);
                }
                if (errors.length > 0) {
                    this.render_errors(errors);
                    return false;
                } else {
                    // get rid of any space/dash characters
                    this.payment_fields.find('.js-sv-wc-payment-gateway-echeck-form-account-number').val(account_number);
                    return true;
                }
            }
            // Public: Render any new errors and bring them into the viewport
            // Returns nothing.
            render_errors(errors) {
                // hide and remove any previous errors
                $('.woocommerce-error, .woocommerce-message').remove();
                // add errors
                this.form.prepend('<ul class="woocommerce-error"><li>' + errors.join('</li><li>') + '</li></ul>');
                // unblock UI
                this.form.removeClass('processing').unblock();
                this.form.find('.input-text, select').blur();
                // scroll to top
                return $('html, body').animate({
                    scrollTop: this.form.offset().top - 100
                }, 1000);
            }
            // Public: Handle associated actions for saved payment methods
            // Returns nothing.
            handle_saved_payment_methods() {
                var $csc_field, $new_payment_method_selection, csc_required, csc_required_for_tokens, id_dasherized;
                // make available inside change events
                id_dasherized = this.id_dasherized;
                csc_required = this.csc_required;
                csc_required_for_tokens = this.csc_required_for_tokens;
                $new_payment_method_selection = $(`div.js-wc-${id_dasherized}-new-payment-method-form`);
                $csc_field = $new_payment_method_selection.find('.js-sv-wc-payment-gateway-credit-card-form-csc').closest('.form-row');
                // show/hide the saved payment methods when a saved payment method is de-selected/selected
                $(`input.js-wc-${this.id_dasherized}-payment-token`).on('change', function() {
                    var tokenized_payment_method_selected;
                    tokenized_payment_method_selected = $(`input.js-wc-${id_dasherized}-payment-token:checked`).val();
                    if (tokenized_payment_method_selected) {
                        // using an existing tokenized payment method, hide the 'new method' fields
                        $new_payment_method_selection.slideUp(200);
                        // move the CSC field out of the 'new method' fields so it can be used with the tokenized transaction
                        if (csc_required_for_tokens) {
                            $csc_field.removeClass('form-row-last').addClass('form-row-first');
                            return $new_payment_method_selection.after($csc_field);
                        }
                    } else {
                        // use new payment method, display the 'new method' fields
                        $new_payment_method_selection.slideDown(200);
                        // move the CSC field back into its regular spot
                        if (csc_required_for_tokens) {
                            $csc_field.removeClass('form-row-first').addClass('form-row-last');
                            return $new_payment_method_selection.find('.js-sv-wc-payment-gateway-credit-card-form-expiry').closest('.form-row').after($csc_field);
                        }
                    }
                }).change();
                // display the 'save payment method' option for guest checkouts if the 'create account' option is checked
                //  but only hide the input if there is a 'create account' checkbox (some themes just display the password)
                $('input#createaccount').on('change', function() {
                    var $parent_row;
                    $parent_row = $(`input.js-wc-${id_dasherized}-tokenize-payment-method`).closest('p.form-row');
                    if ($(this).is(':checked')) {
                        $parent_row.slideDown();
                        return $parent_row.next().show();
                    } else {
                        $parent_row.hide();
                        return $parent_row.next().hide();
                    }
                });
                if (!$('input#createaccount').is(':checked')) return $('input#createaccount').change();
            }
            // Public: Handle showing/hiding the sample check image
            // Returns nothing.
            handle_sample_check_hint() {
                var $sample_check;
                $sample_check = this.payment_fields.find('.js-sv-wc-payment-gateway-echeck-form-sample-check');
                if ($sample_check.is(":visible")) return $sample_check.slideUp();
                else return $sample_check.slideDown();
            }
            // Blocks the payment form UI
            // @since 3.0.0
            block_ui() {
                return this.form.block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
            }
            // Unblocks the payment form UI
            // @since 3.0.0
            unblock_ui() {
                return this.form.unblock();
            }
        };
        // dispatch loaded event
        return $(document.body).trigger("sv_wc_payment_form_handler_v5_15_12_loaded");
    });
}).call($a2c1c221aac1d794$exports);

})();
//# sourceMappingURL=sv-wc-payment-gateway-payment-form.js.map
